import { Component, OnInit, ViewChild } from '@angular/core';
import { TransportAssocService } from 'app/services/transport-assoc.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { ToastrService } from 'ngx-toastr';
import { TRANSPORT_ASSOCIATIONS, TRANSPORT_ASSOCIATIONS_ACTIONS } from 'app/shared/actions/actions.constants';
import { Router } from '@angular/router';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-transport-association-list',
  templateUrl: './transport-association-list.component.html',
  styleUrls: ['./transport-association-list.component.scss']
})
export class TransportAssociationListComponent implements OnInit {
  transports: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;
  page = 1;
  lblHeading = '';
  transportActions = TRANSPORT_ASSOCIATIONS;
  popoverTitle = 'Delete Transport Association';
  popoverMessage = 'Are you sure you want to delete Transport Association?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Transport Association...";
  showNum: number = 10;
  selectedIndex
  editTransportId
  public isLoading = false;
  isEmpty: boolean = false;
  selecttransport:any=null
  @ViewChild('content') modal: NgbModal;
  closeResult =''
  constructor(private service: TransportAssocService,
     private utility: UtilityServiceService,private toastr:ToastrService, private toastService:ToastNotificationService, private router:Router,private modalService:NgbModal,) { }

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
  }

  reload() {
    this.isLoading = true;
    this.service.getAll().subscribe(result => {
      this.transports = result;
      //console.log(this.transports);
      this.utility.onSort(5);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.service.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Transport Association', message: `Transport Association ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastService.success(`Transport Association ${this.removeRef.code} deleted.`,'Delete Transport Association');
      if (result != null) {
        this.onNo();
        this.reload();
        this.modalService.dismissAll();
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Transport Association', message: `Transport Association ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastService.success(`Transport Association ${this.removeRef.code} was not deleted.`,'Delete Transport Association');
    });
  }

  onSort() {
    this.direction = !this.direction;
  }

  onConfirm(doc: any,content) {
    console.log(doc);
    
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Transport Association <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeandig(false);
    // this.isRemove = true;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {

        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }
  onChangeHeading(change: boolean = true) {
    this.lblHeading = (change) ? 'Carrier Types' : 'Delete Carrier Type';
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Transport Associations' : 'Delete Transport Association';
  }
  CheckedTransport(ev: any,optionalVal, res,index) { // Angular 13
    console.log(ev);
    
    this.editTransportId=res?.id
    console.log(this.editTransportId);
    this.selectedIndex = ev.target.checked ? index : undefined;
    if(ev.target.checked){
      this.selecttransport = res;
      
    }else{
      this.selecttransport = null;
    }

	}
  doTransportAction(event:any) { 
    if(event.value ==TRANSPORT_ASSOCIATIONS_ACTIONS.EditTransport) {
     (this.selecttransport == null) ? this.toastService.error('Please select the transport association first!',''):this.router.navigate(['/transport/association/edit',this.editTransportId]);;
      
    } 
    else if(event.value ==TRANSPORT_ASSOCIATIONS_ACTIONS.AddTransport){
      this.router.navigate(['/transport/association/add']);
    }
    else {
      if(event.value = TRANSPORT_ASSOCIATIONS_ACTIONS.DeleteTransport) {
      (this.selecttransport == null) ? this.toastService.error('Please select the transport association first!',''): this.onConfirm(this.selecttransport,this.modal);
      }
    }
  }


}
